<!-- Toast global pour toute l'application -->
<p-toast position="top-right" [baseZIndex]="10000"></p-toast>

<!-- Marqueur d'état de connexion / synchronisation (pastille flottante) -->
<!-- <app-sync-status></app-sync-status> -->

<div class="app-main-container">
    <router-outlet></router-outlet>
</div>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>